/* @ngInject */
const areaRequest = (
  $q,
  utils,
  valueHandler,
  areaResource,
  errorHandler,
  labels
) => {
  const self = {}

  self.getBySearch = async (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$area.getBySearch'
      areaResource.post({ action: 'search', }, { search: _data }, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            areas: res.data,
            message: labels.area.log.search.success(res.data.length),
            color: res.data.length === 0 ? 'orange' : 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.area.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.getAll = async () => {
    return self.getBySearch({})
  }

  self.getById = async (_id) => {
    return $q(async (resolve, reject) => {
      if (!valueHandler.isId(_id)) {
        reject(labels.area.fields.id.invalid)
      }

      try {
        const response = await self.getBySearch({ id: _id, })
        const areas = response.areas
        if (areas.length === 1) {
          resolve(areas[0])
        } else {
          reject(labels.area.log.search.noResultWithId)
        }
      } catch (error) {
        reject(error)
      }
    })
  }

  self.getByName = async (_name) => {
    return $q(async (resolve, reject) => {
      if (!valueHandler.isString(_name)) {
        reject(labels.area.fields.name.invalid)
      }

      try {
        const response = await self.getBySearch({ name: _name, })
        const areas = response.areas
        if (areas.length === 1) {
          resolve(areas[0])
        } else {
          reject(labels.area.log.search.noResultWithId)
        }
      } catch (error) {
        reject(error)
      }
    })
  }

  self.save = (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$area.save'

      areaResource.save({}, _data, (res) => {
        if (res && res.success && valueHandler.isId(res.data.id)) {
          const response = {
            id: res.data.id,
            message: labels.area.log.save.success,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 2) {
            reject(labels.area.log.save.alreadyExists)
          } else {
            errorHandler.message(res, functionName, _data)
            reject(labels.area.log.save.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.update = (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$area.update'
      areaResource.update({ action: _data.id }, _data, (res) => {
        if (res && res.success) {
          const response = {
            area: res.data,
            message: labels.area.log.update.success,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.area.log.update.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.delete = async (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$area.delete'
      areaResource.delete({ action: _id, }, (res) => {
        if (res && res.success) {
          resolve(labels.area.log.delete.success)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 23000) {
            reject(labels.area.log.delete.railwayOnArea)
          } else if (res.code === 2) {
            reject(labels.area.log.delete.arrivalArea)
          } else if (res.code === 3) {
            reject(labels.area.log.delete.departureArea)
          } else {
            errorHandler.message(res, functionName, _id)
            reject(labels.area.log.delete.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return self
}

export default areaRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/services/request.service.js